import { twMerge } from '@/lib/classname/twMerge'
import { type VariantProps, cva } from 'class-variance-authority'

const overlayCva = cva('fixed before:absolute before:inset-0 before:block before:bg-black', {
  variants: {
    isVisible: {
      true: 'before:opacity-40',
      false: 'pointer-events-none before:opacity-0',
    },
  },
})

type OverlayVariantProps = VariantProps<typeof overlayCva>

export type OverlayProps = Required<OverlayVariantProps> & {
  className?: string
  onClick?: () => void
}

export function Overlay({
  isVisible,
  className,
  onClick,
  ...props
}: OverlayProps): React.ReactElement {
  return (
    <div
      {...props}
      className={twMerge(className, overlayCva({ isVisible }))}
      data-testid="overlay"
      onClick={onClick}
    />
  )
}
